
angular.module('flipto.components.common.modelOperations', []);